import {useCallback} from 'react'
import { useMatomo } from '@datapunt/matomo-tracker-react'

const useTrackPageView = () => {
  const { trackPageView } = useMatomo()

  return useCallback(() => {
    try {
      // @ts-ignore
      trackPageView()
    } catch (e) {
      console.error('Unable to track page visit', e)
    }

  }, [])
}

export default useTrackPageView
